import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import { node } from 'prop-types';

import Favicon from '@assets/images/arin-miftah-favicon.png';
import '@assets/css/icomoon.css';
import '@assets/css/bootstrap.css'; 
import '@assets/css/style.css';

import IMAGE_URL from '@assets/images/comprimida.jpg';
const META_DESCRIPTION = `Hola, para nosotros es un gusto invitarte a nuestra boda.`;

function MainLayout({ children }) {
  return (
    <Fragment>
      <Helmet>
        <title>Scarlette & Waldemar</title>

        {/* Favicon */}
        <link rel="icon" type="image/png" href={Favicon} />

        {/* font and SEO tags */}
        <meta property="og:image:width" content="1200"/>
        <meta property="og:image:height" content="630"/>
        <meta property="og:title" content="The Wedding of Scarlette & Waldemar" />
        <meta property="og:image" itemprop="image" content={IMAGE_URL} />
        <meta property="og:url" content="https://scarletteywaldemar.com" />
        <meta property="og:site_name" content="The Wedding of Scarlette & Waldemar" />
        <meta property="og:description" content={META_DESCRIPTION} />
        <meta property="og:type" content="website" />
          <link
            href="https://fonts.googleapis.com/css?family=Work+Sans:400,300,600,400italic,700"
            rel="stylesheet"
            type="text/css"
          />
          <link href="https://fonts.googleapis.com/css2?family=Cookie&display=swap" rel="stylesheet"></link>
      </Helmet>
      <div id="page">{children}</div>
    </Fragment>
  );
}

MainLayout.propTypes = {
  children: node.isRequired,
};

export default MainLayout;
